import { render, staticRenderFns } from "./authorityList.vue?vue&type=template&id=e94848b2&scoped=true"
import script from "./authorityList.vue?vue&type=script&lang=js"
export * from "./authorityList.vue?vue&type=script&lang=js"
import style0 from "./authorityList.vue?vue&type=style&index=0&id=e94848b2&prod&lang=scss&scoped=true"
import style1 from "./authorityList.vue?vue&type=style&index=1&id=e94848b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94848b2",
  null
  
)

export default component.exports